import React from 'react';
export function PressQuoteSection() {
  return <section className="bg-cream py-[60px] md:py-[100px] px-6" data-id="element-149">
      <div className="max-w-[900px] mx-auto text-center" data-id="element-150">
        <span className="block text-label mb-8" data-id="element-151">Awards & Media</span>

        <blockquote className="mb-8" data-id="element-152">
          <p className="text-[20px] md:text-[24px] leading-relaxed font-normal italic text-charcoal" data-id="element-153">
            "The first Shiraz we tasted was on the day we arrived: Glenlofty's
            2023 from the rugged Pyrenees subregion with its cold winters and
            cool nights. It was the first time I'd encountered Shiraz like this.
            Like nothing from anywhere else."
          </p>
        </blockquote>

        <cite className="block text-[16px] font-light text-gold not-italic uppercase tracking-wide" data-id="element-154">
          — Tamlyn Currin, JancisRobinson.com
        </cite>
      </div>
    </section>;
}